
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.243 2H8.34a.5.5 0 01.453.711L7.375 5.752a4 4 0 00-.276.807.549.549 0 01-.522.441H2.446A.446.446 0 012 6.554c0-.355.14-.695.392-.946l2.73-2.73A3 3 0 017.241 2zM14.95 7a2.008 2.008 0 00-.138-.402l-2.01-4.31A.5.5 0 0012.347 2h-.696a.5.5 0 00-.453.289L9.188 6.598A2 2 0 009 7.444V11a1 1 0 001 1h4a1 1 0 001-1V7.444c0-.15-.017-.299-.05-.444zM16.901 6.56c.056.248.267.44.522.44h4.131C21.8 7 22 6.8 22 6.554c0-.355-.14-.695-.392-.946l-2.73-2.73A3 3 0 0016.759 2h-1.1a.5.5 0 00-.452.711l1.419 3.041c.12.26.213.53.276.807z"}}),_c('path',{attrs:{"d":"M3 9h3.5a.5.5 0 01.5.5V11a3 3 0 003 3h4a3 3 0 003-3V9.5a.5.5 0 01.5-.5H21a1 1 0 011 1v9a3 3 0 01-3 3H5a3 3 0 01-3-3v-9a1 1 0 011-1z"}})])
          )
        }
      }
    